// extracted by mini-css-extract-plugin
export default {"container":"car-damage-icon_container__8XJsc","container_empty":"car-damage-icon_container_empty__pw1G+"};